import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";
import { getTimezoneLabel } from "../utils/timezone-utils";

interface TimezoneIndicatorProps {
  timezoneId: string;
  className?: string;
}

export function TimezoneIndicator({
  timezoneId,
  className,
}: TimezoneIndicatorProps) {
  const label = getTimezoneLabel(timezoneId);

  return (
    <div
      className={cn(
        "px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-700 flex items-center gap-2",
        className,
      )}
    >
      <Clock className="h-4 w-4" />
      <span>
        Timesheet entries use <strong>{label.full}</strong> ({label.short})
      </span>
    </div>
  );
}
